import connectifyproject from '../assets/images/connectifyprojects.png';

const Connectify = () => {
  return (
    <div>
      <a href='#projects'><strong>MERN</strong> App</a>
      <img src={connectifyproject} alt='connectify' className='' />
    </div>
  )
}

export default Connectify;